/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Resource_McpInputs */

const en_directory_agents_resource_mcp = /** @type {(inputs: Directory_Agents_Resource_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The remote MCP server and client setup for Claude Code, Cursor, and Codex.`)
};

const zh_directory_agents_resource_mcp = /** @type {(inputs: Directory_Agents_Resource_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`远程 MCP 服务器与 Claude Code、Cursor、Codex 的接入配置。`)
};

/**
* | output |
* | --- |
* | "The remote MCP server and client setup for Claude Code, Cursor, and Codex." |
*
* @param {Directory_Agents_Resource_McpInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_resource_mcp = /** @type {((inputs?: Directory_Agents_Resource_McpInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Resource_McpInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_resource_mcp(inputs)
	return zh_directory_agents_resource_mcp(inputs)
});
export { directory_agents_resource_mcp as "directory.agents.resource_mcp" }